import { Component } from "react";
import * as React from "react";

export interface YearCardProps {
    className?: string;
    onDragStart: (item: string) => void;
    onDragEnd: (item: string) => void;
    yearItem?: string;
}

interface YearCardState {
}

export default class YearCard extends Component<YearCardProps, YearCardState>
{

    constructor(props: Readonly<YearCardProps>) {
        super(props);

        this.state = {
        }
    }

    public componentDidMount() {
    }


    public render() {

        return (
            <div className={`card card--thin card--padded card--margin-small flex-row ${this.props.className ? this.props.className : ""}`}
                key={this.props.yearItem}
                draggable={true}
                onDragStart={() => { this.props.onDragStart(this.props.yearItem!) }}
                onDragOver={(e) => e.preventDefault()}
                onDragEnd={() => {this.props.onDragEnd(this.props.yearItem!)} }>

                <div className={"flex-row flex-item--flex-1"}>
                    <span className={"flex-item--flex-1"}>{this.props.yearItem}</span>
                </div>
            </div>
        );
    }
}